import {analyticsLogEvent} from '../api'

const eventName = 'custom_event'

/**
 * Tracks users who click on size chart inside the footer.
 *
 * @param {Object} params - Object containing the event parameters.
 * @param {Category} params.category - Category of the event (e.g., "Size Chart Footer", "Size Chart")
 * @param {string} params.action - Description of the action performed (e.g., "open").
 */
export function analyticsEventStoriesMenuClick({action}: {action: string}) {
    const eventDetails = {
        eventCategory: 'stories_menu_click',
        eventAction: action,
        eventLabel: 'click',
    }

    analyticsLogEvent(eventName, eventDetails)
}
